<!--
/*
 * This file is part of peacohrm Inc
 *
 * Copyright (C) 2020 onwards peacohrm Inc
 *
 * This program is free software; you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation; either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see  http://www.gnu.org/licenses
 */
-->

<template>
  <g transform="matrix(0.976563, 0, 0, 0.976563, 0, 0)">
    <path
      d="M293.5,250c35.841,0,65-29.159,65-65s-29.159-65-65-65s-65,29.159-65,65S257.659,250,293.5,250z M293.5,150   c19.299,0,35,15.701,35,35s-15.701,35-35,35s-35-15.701-35-35S274.201,150,293.5,150z"
    />
    <path
      d="M293.5,60C206.103,60,135,131.103,135,218.5S206.103,377,293.5,377S452,305.897,452,218.5S380.897,60,293.5,60z M293.5,90   C364.355,90,422,147.645,422,218.5c0,28.265-9.18,54.422-24.706,75.662C384.645,285.047,369.373,280,353.497,280H233.498   c-15.874,0-31.146,5.046-43.794,14.16C174.18,272.92,165,246.764,165,218.5C165,147.645,222.645,90,293.5,90z M210.379,316.411   c6.915-4.15,14.885-6.411,23.119-6.411h119.999c8.235,0,16.206,2.261,23.121,6.413C354.195,335.477,325.17,347,293.5,347   C261.829,347,232.803,335.477,210.379,316.411z"
    />
    <path
      d="M448.003,63.997C406.733,22.728,351.863,0,293.5,0S180.267,22.728,138.997,63.997S75,160.136,75,218.5   c0,43.062,12.386,84.213,35.449,119.412L13.181,435.18C4.682,443.68,0,454.98,0,467s4.682,23.32,13.181,31.819   C21.68,507.319,32.98,512,45,512c12.021,0,23.321-4.682,31.819-13.181l97.269-97.269C209.287,424.614,250.439,437,293.5,437   c58.363,0,113.233-22.728,154.503-63.997S512,276.864,512,218.5S489.272,105.266,448.003,63.997z M55.605,477.607   C52.773,480.44,49.007,482,45,482c-4.006,0-7.773-1.561-10.606-4.394C31.561,474.773,30,471.006,30,467s1.561-7.773,4.394-10.606   l51.571-51.571l21.213,21.213L55.605,477.607z M128.39,404.823l-21.213-21.213l21.578-21.578   c3.278,3.751,6.686,7.415,10.242,10.971c3.556,3.556,7.22,6.964,10.971,10.242L128.39,404.823z M293.5,407   C189.561,407,105,322.439,105,218.5S189.561,30,293.5,30S482,114.561,482,218.5S397.439,407,293.5,407z"
    />
  </g>
</template>
